module.exports = __webpack_public_path__ + "img/post_image.010f7f85.png";